// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SmartIdButton_reset-list_2z5Ov{margin:0;padding:0;list-style:none;display:block}.SmartIdButton_uppercase-sm_39tuW{font-size:12px;text-transform:uppercase;letter-spacing:.03667em}.SmartIdButton_icon_JmApv{display:block;width:112px;height:auto}", ""]);
// Exports
exports.locals = {
	"reset-list": "SmartIdButton_reset-list_2z5Ov",
	"uppercase-sm": "SmartIdButton_uppercase-sm_39tuW",
	"icon": "SmartIdButton_icon_JmApv"
};
module.exports = exports;
